export default __webpack_public_path__ + "static/media/splash.e91c8659.png";